import React from 'react';
import { Component } from 'react';

import { connect } from 'react-redux';
import { setError, setSuccess } from '../../redux/actions';

class Alerts extends Component {
  componentDidMount() {
    this.props.setError('');
    this.props.setSuccess('');
  }
  render() {
    // console.log(this.props.message)
    return (
      <div>
        <div style={baseStyles.error}>{this.props.message.error}</div>
        <div style={baseStyles.success}>{this.props.message.success}</div>
      </div>
    );
  }
}

const baseStyles = {
  error: {
    fontWeight: 'bold',
    color: '#f7183a',
  },
  success: {
    fontWeight: 'bold',
    color: '#4CAF50',
  },
};
const mapStateToProps = (state) => {
  return {
    message: state.message,
  };
};
const mapDispatchToProps = {
  setError,
  setSuccess,
};
export default connect(mapStateToProps, mapDispatchToProps)(Alerts); //{JSON.stringify(this.props.user)}
